import styled from 'styled-components';

export const DivCellText = styled.div({
  border: `0px solid var(--ds-border-base)`,
  color: (props) =>
    props.$isName
      ? props.$isStacked
        ? '#38598c'
        : 'var(--ds-text-title)'
      : 'var(--ds-text-secondary)',
  fontFamily: 'proxima-nova',
  fontSize: (props) =>
    props.$isName
      ? props.$isStacked
        ? `${16 - 1 * props.$level}px`
        : '13px'
      : '13px',
  fontWeight: (props) => (props.$isName ? '600' : '500'),
  overflow: 'hidden',
  paddingLeft: 5,
  textOverflow: 'ellipsis',
  width: '100%',
  height: '100%',
  minHeight: '28px',
  // pour afficher le label dyn
  containerType: 'inline-size',
  containerName: 'cell',
  display: 'flex',
  alignItems: 'center',

  '&::before': {
    content: 'attr(data-label)',
    display: 'none',
    color: '#888',
    fontSize: 12,
    marginRight: 4,
  },

  // Quand la largeur du container > 150px
  '@container cell (min-width: 150px)': {
    '&::before': {
      display: (props) =>
        !props.$isName && props.$isStacked ? 'inline' : 'none',
    },
  },
});

export const DataCellYesNoContainer = styled.div({
  width: '20px',
  height: '20px',
});

export const DataCellNumberContainer = styled.div({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  containerType: 'inline-size',
  containerName: 'cell',
  height: '100%',
  minWidth: '50px',
});

export const DataCellLabel = styled.div({
  display: 'none', // caché par défaut
  marginRight: 6,
  color: 'var(--ds-text-secondary)',
  fontSize: 12,
  fontWeight: 500,
  width: '100px',

  '@container cell (min-width: 150px)': {
    display: 'inline', // visible seulement si > 200px
  },
});

export const DataCellNumberValue = styled.div({
  color: 'var(--ds-text-base)',
  fontFamily: 'proxima-nova',
  fontSize: 12,
  fontWeight: '500',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: (props) =>
    props.$isStacked ? 'calc(100% - 120px)' : 'calc(100% - 20px)',
  minWidth: (props) => (props.$isStacked ? '50px' : '50px'),
  maxWidth: (props) => (props.$isStacked ? '200px' : '100px'),
  paddingLeft: '5px',
});

export const DataCellCrumbtrailContainer = styled.div({
  height: 'auto',
  marginTop: '2px',
  paddingLeft: '4px',
  overflow: 'hidden',
  display: 'flex',
  flexWrap: 'wrap',
});

export const DataCellCrumbtrailItem = styled.div({
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--ds-text-title)',
  backgroundColor: 'var(--ds-bg-secondary)',
  padding: '3px 3px 3px 3px',
  margin: '2px 4px 0px 4px',
  borderRadius: '3px',
  height: '22px',
  '&:hover': {
    fontWeight: 900,
    backgroundColor: 'var(--ds-bg-base)',
  },
});

export const DataCellCrumbtrailSeparator = styled.div({
  fontWeight: 600,
  fontSize: '9px',
  color: 'var(--ds-text-title)',
  lineHeight: '22px',
  padding: '3px 3px 3px 3px',
  margin: '2px 4px 0px 4px',
});
